import { CHECKOUT_CONTACT_SUCCESS } from 'store/actionTypes/checkout'

export const checkoutContactActionSuccess = (payload) => ({
  type: CHECKOUT_CONTACT_SUCCESS,
  payload,
})
